exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clanblack[data-v-16bf86fd]{font-family:ClanFFBlack!important;font-weight:400}.clanpro[data-v-16bf86fd]{font-family:ClanPro!important;font-weight:400}.clanprobold[data-v-16bf86fd]{font-family:ClanProBold!important;font-weight:400}.clanprobook[data-v-16bf86fd]{font-family:ClanProBook!important;font-weight:400}.scanning-field[data-v-16bf86fd]{margin-bottom:20px;border:1px solid #1aae7c}.scan-mode[data-v-16bf86fd]{margin-bottom:10px}.camera-inline[data-v-16bf86fd]{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16bf86fd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BusinessReturnMobile/BusinessReturnMobileForm.vue
// module id = 792
// module chunks = 0